import { InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

/**
 * Input component with dark mode styling
 * Minimum height: 44px for touch targets
 * Dark background with border and focus states
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', ...props }, ref) => {
    const baseStyles = 'bg-tertiary-bg border border-input-border rounded-lg px-4 py-3 text-primary-text placeholder-secondary-text focus:outline-none focus:border-input-focus focus:ring-1 focus:ring-input-focus min-h-[44px] transition-colors';
    
    const errorStyles = error ? 'border-error focus:border-error focus:ring-error' : '';
    
    const classes = `${baseStyles} ${errorStyles} ${className}`.trim();
    
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-primary-text mb-2">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={classes}
          {...props}
        />
        {error && (
          <p className="mt-1 text-sm text-error">{error}</p>
        )}
        {helperText && !error && (
          <p className="mt-1 text-sm text-secondary-text">{helperText}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';












